import { defineStyleConfig as t } from "@chakra-ui/react";
const l = t({
  variants: {
    h1: {
      textStyle: "h1"
    },
    h2: {
      textStyle: "h2"
    },
    h3: {
      textStyle: "h3"
    },
    h4: {
      textStyle: "h4"
    },
    subheading1: {
      textStyle: "subheading1"
    },
    subheading2: {
      textStyle: "subheading2"
    },
    body: {
      textStyle: "body"
    },
    bodyBold: {
      textStyle: "bodyBold"
    },
    bodySmall: {
      textStyle: "bodySmall"
    },
    bodyBoldSmall: {
      textStyle: "bodyBoldSmall"
    }
  },
  baseStyle: {},
  sizes: {},
  defaultProps: {}
});
export {
  l as default
};
